if (typeof QuickAddComponent === "function") {
  console.log("QuickAddComponent is declared.");
} else {
  console.log("QuickAddComponent is not declared.");
  class QuickAddComponent {
    constructor() {
      this.initEventListeners();
    }

    initEventListeners() {
      // Handle variant product clicks
      document.addEventListener("click", (e) => {
        const variantTrigger = e.target.closest(
          ".quick-add__trigger--variants"
        );
        if (variantTrigger) {
          e.preventDefault();
          e.stopPropagation();
          this.toggleOverlay(variantTrigger);
        }

        // Handle variant selection
        const variantBtn = e.target.closest(".quick-add-variant-btn");
        if (
          variantBtn &&
          !variantBtn.disabled &&
          !variantBtn.classList.contains("variant-unavailable")
        ) {
          e.preventDefault();
          e.stopPropagation();
          this.addVariantToCart(variantBtn);
        }

        // Close overlay when clicking on overlay background
        const overlay = e.target.closest(".quick-add-overlay");
        if (overlay && e.target === overlay) {
          e.preventDefault();
          e.stopPropagation();
          this.closeAllOverlays();
        }
      });

      // Close overlays when clicking outside component
      document.addEventListener("click", (e) => {
        if (
          !e.target.closest("[data-quick-add-image-wrapper]") &&
          !e.target.closest(".quick-add-component")
        ) {
          this.closeAllOverlays();
        }
      });

      // Handle form submissions for single variant products
      document.addEventListener("submit", (e) => {
        const form = e.target.closest(".quick-add-form");
        if (form) {
          e.preventDefault();
          this.handleFormSubmit(form);
        }
      });

      // Handle escape key
      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") {
          this.closeAllOverlays();
        }
      });
    }

    toggleOverlay(trigger) {
      const component = trigger.closest(".quick-add-component");
      const productId = component.dataset.productId;

      // Find the image wrapper that contains this quick-add component
      const imageWrapper = trigger.closest("[data-quick-add-image-wrapper]");
      if (!imageWrapper) {
        console.error("Could not find image wrapper for quick add overlay");
        return;
      }

      // Look for overlay within the image wrapper or as a sibling
      let overlay = imageWrapper.querySelector(
        `#quick-add-overlay-${productId}`
      );

      // If not found in image wrapper, look for it as a sibling or in parent card
      if (!overlay) {
        const card = imageWrapper.closest(".card-wrapper, .card");
        if (card) {
          overlay = card.querySelector(`#quick-add-overlay-${productId}`);
        }
      }

      if (!overlay) {
        console.error(
          `Could not find overlay with ID: quick-add-overlay-${productId}`
        );
        return;
      }

      // Close other open overlays first
      this.closeAllOverlays();

      if (overlay.style.display === "none" || !overlay.style.display) {
        overlay.style.display = "flex";
      } else {
        overlay.style.display = "none";
      }
    }

    closeAllOverlays() {
      const openOverlays = document.querySelectorAll(".quick-add-overlay");
      openOverlays.forEach((overlay) => {
        overlay.style.display = "none";
      });
      document.body.style.overflow = "";
    }

    async addVariantToCart(variantBtn) {
      const variantId = variantBtn.dataset.variantId;
      const isAvailable = variantBtn.dataset.variantAvailable === "true";

      if (!isAvailable) return;

      // Show loading state
      variantBtn.classList.add("loading");
      variantBtn.style.opacity = "0.7";
      variantBtn.style.pointerEvents = "none";

      // Get cart element for rendering (same as product-form.js)
      const cart =
        document.querySelector("cart-notification") ||
        document.querySelector("cart-drawer");

      try {
        // Use the same approach as product-form.js
        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData();
        formData.append("id", variantId);
        formData.append("quantity", 1);

        if (cart) {
          formData.append(
            "sections",
            cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        const response = await fetch(`${routes.cart_add_url}`, config);
        const result = await response.json();

        if (result.status) {
          // Handle error
          console.error(
            "Add to cart error:",
            result.description || result.message
          );
          this.handleAddToCartError(result);
          return;
        }

        // Success - use the same rendering approach as product-form.js
        if (!cart) {
          window.location = window.routes.cart_url;
          return;
        }

        // Publish cart update event (same as product-form.js)
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "product-form",
          productVariantId: variantId,
          cartData: result,
        });

        // Render cart contents with the response
        cart.renderContents(result);

        // Close overlays after successful add
        this.closeAllOverlays();
      } catch (error) {
        console.error("Add to cart error:", error);
        this.handleAddToCartError(error);
      } finally {
        // Reset loading state
        variantBtn.classList.remove("loading");
        variantBtn.style.opacity = "";
        variantBtn.style.pointerEvents = "";

        // Remove is-empty class from cart if it exists (same as product-form.js)
        if (cart && cart.classList.contains("is-empty")) {
          cart.classList.remove("is-empty");
        }
      }
    }

    async handleFormSubmit(form) {
      const submitBtn = form.querySelector(".quick-add__trigger");
      const variantId = form.querySelector(".product-variant-id").value;

      // Show loading state
      submitBtn.classList.add("loading");
      submitBtn.disabled = true;

      // Get cart element for rendering
      const cart =
        document.querySelector("cart-notification") ||
        document.querySelector("cart-drawer");

      try {
        // Use the same approach as product-form.js
        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(form);

        if (cart) {
          formData.append(
            "sections",
            cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        const response = await fetch(`${routes.cart_add_url}`, config);
        const result = await response.json();

        if (result.status) {
          // Handle error
          console.error(
            "Add to cart error:",
            result.description || result.message
          );
          this.handleAddToCartError(result);
          return;
        }

        // Success - use the same rendering approach as product-form.js
        if (!cart) {
          window.location = window.routes.cart_url;
          return;
        }

        // Publish cart update event
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "product-form",
          productVariantId: variantId,
          cartData: result,
        });

        // Render cart contents with the response
        cart.renderContents(result);
      } catch (error) {
        console.error("Add to cart error:", error);
        this.handleAddToCartError(error);
      } finally {
        // Reset loading state
        submitBtn.classList.remove("loading");
        submitBtn.disabled = false;

        // Remove is-empty class from cart if it exists (same as product-form.js)
        if (cart && cart.classList.contains("is-empty")) {
          cart.classList.remove("is-empty");
        }
      }
    }

    handleAddToCartError(error) {
      console.error("Quick add error:", error);

      // Could add user-facing error message here if needed
      // For now, just log the error
    }
  }

  // Initialize when DOM is loaded
  document.addEventListener("DOMContentLoaded", () => {
    new QuickAddComponent();
  });
}